import { render, staticRenderFns } from "./MessageLinkPreview.vue?vue&type=template&id=0d38d266&"
import script from "./MessageLinkPreview.vue?vue&type=script&lang=js&"
export * from "./MessageLinkPreview.vue?vue&type=script&lang=js&"
import style0 from "./MessageLinkPreview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports